module.exports = __webpack_public_path__ + "img/darts.b322d852.svg";